import type { LicensingRuleType, PolicyAction } from '../../../../shared/model-typings';
import type { LicensingRule } from '../../../types';

export const licensingRuleTypeToAction = (type: LicensingRuleType): PolicyAction => {
  switch (type) {
    case 'denied_license':
      return 'DENY';
    case 'flagged_license':
      return 'FLAG';
    case 'approved_license':
    default:
      return 'APPROVE';
  }
};

export const licensingRuleTypeToActionRevamp = (type: LicensingRuleType, isPlural: boolean = false): string => {
  switch (type) {
    case 'denied_license':
      return `Deny ${isPlural ? 'Licenses' : 'License'}`;
    case 'flagged_license':
      return `Flag ${isPlural ? 'Licenses' : 'License'}`;
    case 'approved_license':
    default:
      return `Approve ${isPlural ? 'Licenses' : 'License'}`;
  }
};

// A license can have rules in several columns (with different conditions), so select rules by
// license and column, never by license alone.
export const rulesInColumn = (rules: LicensingRule[], selectedLicenses: Set<string>, ruleType: LicensingRuleType) =>
  rules.filter((rule) => rule.type === ruleType && selectedLicenses.has(rule.licenseId));
